/* @ngInject */
export default class httpIntercetorService {
	constructor($q, $rootScope, $injector, HPConfig, AuthenticationFactory, requestHandlerService) {
		this.$q = $q;
		this.$rootScope = $rootScope;
		this.$injector = $injector;
		this.HPConfig = HPConfig;
		this.AuthenticationFactory = AuthenticationFactory;
		this.requestHandlerService = requestHandlerService;
	}

	request = (config) => {
		var authData = this.AuthenticationFactory.getAuthenticationData();

		//If Auth data exists, retrieve from LocalStorage
		if (authData && config.url.indexOf(this.HPConfig.heroProApi) >= 0) {
			config.headers = config.headers || {};

			config.headers.common = config.headers.common || {};

			config.headers.common["X-RACtx"] = 'sa=' + this.HPConfig.applicationSource;

			if (authData.access_token) {
				config.headers.Authorization = 'Bearer ' + authData.access_token;
			}
			if (authData.secret_key) {
				config.headers.common["X-RACtx"] = 'sk=' + authData.secret_key + '&sa=' + this.HPConfig.applicationSource;
			}
		}
		return config;
	}

	response = (resp) => {
		var headerRACtx = this._parseHeaderRACtx(resp.headers("X-RACtx"));
		if (headerRACtx.sv !== null) {
			if (this.HPConfig.apiVersion === "unknown") {
				this.HPConfig.apiVersion = headerRACtx.sv;
			} else if (this.HPConfig.apiVersion !== headerRACtx.sv) {
				// alert ("refresh");
			}
		}
		return resp || this.$q.when(resp);
	}

	responseError = (rejection) => {

		var deferred = this.$q.defer();

		var eventName = "";

		// Parsing header X-RACtx into an object
		rejection.headerRACtx = this._parseHeaderRACtx(rejection.headers("X-RACtx"));

		// Not Authenticated
		if (rejection.status === 401) {

			//check to see if the mutex has already been claimed... if so create a new promise of the request to do work and enqueue it
			if (this.requestHandlerService.pendingNewRefreshToken === true) {

				var deferredFunction = (success) => {
					var _config = rejection.config;
					var _deffered = deferred;
					if (success) {
						this._retryHttpRequest(_config, _deffered);
					} else {
						_deffered.reject(rejection);
					}
				};

				this.requestHandlerService.AddNewDeferred(deferredFunction);

				return deferred.promise;
			}

			//otherwise claim the mutex and try and get a new token.. if successful then release the mutex and tell the refreshTokenService to process the pending requests
			//if unsuccessful then reject the list of promises waiting and log out.
			this.requestHandlerService.pendingNewRefreshToken = true;

			var authenticationService = this.$injector.get('authenticationService');
			authenticationService.refreshToken().then( () => {

				this.requestHandlerService.finishedRefresh(true);
				this._retryHttpRequest(rejection.config, deferred);
			}, () => {

				this.requestHandlerService.finishedRefresh(false);
				authenticationService.logOut(this.$injector.get('$stateParams'));
				/*$state.go('login');*/
			});
			eventName = "HPErrorUnauthorized";
		}

		// Forbidden
		else if (rejection.status === 403) {
			eventName = "HPErrorForbidden";
		}

		// Not Found
		else if (rejection.status === 404) {
			eventName = "HPErrorNotFound";
		}

		// Internal server error / timeout (transaction id)
		else if (rejection.status === 500) {
			eventName = "HPErrorServer";
		}

		// Default to any other error
		else {
			eventName = "HPErrorUnknown";
		}

		deferred.reject(rejection);
		this.$rootScope.$broadcast(eventName, rejection);

		return deferred.promise;

	}


	// private functions
	_parseHeaderRACtx(headerRACtx) {
		var headerRACtxObject = {};
		if (headerRACtx !== null) {
			headerRACtx = headerRACtx.split("&");
			for (var i = 0; i < headerRACtx.length; i++) {
				var headerSplit = headerRACtx[i].split("=");
				headerRACtxObject[headerSplit[0]] = headerSplit[1];
			}
		}
		return headerRACtxObject;
	}

	_retryHttpRequest(config, deferred) {
		$http = $http || this.$injector.get('$http');
		$http(config).then(function (response) {
			deferred.resolve(response);
		}, function (response) {
			deferred.reject(response);
		});
	};

}



// WEBPACK FOOTER //
// ./src/app/common/httpError/httpInterceptorFactory.js